import { useHighlights } from "./js/highlights"
import { useCountups } from "./js/countups"
import { initForm } from "./js/form"
import { initUtm } from "./js/utm"

useHighlights(document)
useCountups(document)

document.addEventListener("DOMContentLoaded", (e) => {
  document.querySelectorAll("a[href^=\"#\"]").forEach(anchor => {
    anchor.addEventListener("click", (e) => {
      e.preventDefault()

      document.querySelector(e.target.getAttribute("href")).scrollIntoView({
          behavior: "smooth"
      })
    })
  })
})

initUtm({
  form: document.querySelector('#orcamento form'),
})

initForm({
  form: document.querySelector('#orcamento form'),
  sendTo: 'https://crm.desbrave.com.br/api/v1/accounts/gpool/leads',
  redirectTo: '/sucesso.html',
})
